module.exports = __webpack_public_path__ + "img/test-voice.4cc85a01.png";